(function ($) {
    function setTableWidth() {
        var width = $(document).width();
        if (width >= 768) {
            $(".dynamicchart").find('td').each(function () {
                var colwidth = $(this).attr("data-desktop-width");
                $(this).css('width', colwidth);
            });
        }
        else {
            $(".dynamicchart").find('td').each(function () {
                var colclass = $(this).attr("data-mobile-width");
                $(this).addClass(colclass);

                if ($(this).attr("data-hidden").toLowerCase() === "true") {
                    $(this).css('display', 'none');
                }
            });
        }
    }

    $(document).ready(function () {      
        setTableWidth();
    });

    $(window).resize(function () {
        setTableWidth();
    });
    
}(window.jQuery));